var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M39.3,30.6L27.9,9c-1.3-2.2-3-4-5.4-4s-4.1,1.8-5.4,4L5.6,30.7c-0.8,2.1-0.8,4.4,0.2,6.4 c0.8,1.7,2.4,2.8,4.3,2.9h24.8c1.9-0.1,3.5-1.2,4.3-2.9C40.2,35.1,40.3,32.7,39.3,30.6z M37.1,35.6c-0.4,0.9-1.2,1.4-2.2,1.5H10.1 c-1-0.1-1.8-0.6-2.2-1.5c-0.5-1.1-0.5-2.4-0.1-3.5l11.3-21.5c0.8-1.4,1.8-2.7,3.4-2.7s2.6,1.3,3.4,2.7l11.3,21.5 C37.6,33.2,37.6,34.5,37.1,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.9,10.6c-0.8-1.4-1.8-2.7-3.4-2.7s-2.6,1.3-3.4,2.7L7.8,32.1c-0.4,1.1-0.4,2.4,0.1,3.5 c0.4,0.9,1.2,1.4,2.2,1.5h24.8c1-0.1,1.8-0.6,2.2-1.5c0.5-1.1,0.5-2.4,0.1-3.5L25.9,10.6z M22.5,16.3c1.1,0.1,2,1.1,1.9,2.2 L23.7,25c0.1,0.7-0.5,1.4-1.2,1.5c-0.7,0-1.2-0.7-1.3-1.5l-0.6-6.5C20.5,17.4,21.4,16.4,22.5,16.3z M22.6,33c0,0-0.1,0-0.1,0 c-1.1,0-2-1-1.9-2.1c0,0,0-0.1,0-0.1c-0.1-1.1,0.8-2,1.9-2.1c0,0,0,0,0,0c1.1,0.1,2,1,1.9,2.1c0,0,0,0,0,0 C24.5,31.9,23.7,32.9,22.6,33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M24.4,30.8c0.1-1.1-0.8-2-1.9-2.1c0,0,0,0,0,0c-1.1,0.1-2,1-1.9,2.1c0,0,0,0.1,0,0.1c0,1.1,0.8,2,1.9,2.1 c0,0,0.1,0,0.1,0C23.7,32.9,24.5,31.9,24.4,30.8C24.4,30.8,24.4,30.8,24.4,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M22.5,26.5c0.7-0.1,1.3-0.8,1.2-1.5l0.7-6.5c0.1-1.1-0.8-2.1-1.9-2.2c-1.1,0.1-2,1.1-1.9,2.2l0.6,6.5 C21.3,25.8,21.8,26.5,22.5,26.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.527936dd83589210ccb45cb939f2912e.svg";
export { ForwardRef as ReactComponent };